<template>
  <div>
    <b-input-group class="">
      <b-form-input
        id="master_input"
        v-model="input_date"
        type="text"
        size="sm"
        placeholder="DD/MM/YYYY"
        autocomplete="off"
        :required="required"
        :disabled="disabled"
      >
      </b-form-input>
      <b-input-group-append>
        <b-form-datepicker
          id="master_datepicker"
          v-model="pick_date"
          button-only
          size="sm"
          right
          locale="en-US"
          start-weekday="1"
          :disabled="disabled"
          :hidden="hidden"
        >
        </b-form-datepicker>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: "MasterDatePicker",
  props: ["value", "required", "disabled", "hidden"],
  data() {
    return {
      pick_date: null,
    };
  },
  watch: {
    pick_date: function(newValue, oldValue) {
      if (newValue != oldValue && this.checkValidPickDate(newValue)) {
        var date_split = newValue.split("-");
        //yyyy-MM-dd => dd/MM/yyyy
        this.input_date =
          date_split[2] + "/" + date_split[1] + "/" + date_split[0];
      }
    },
    input_date: function(newValue, oldValue) {
      if (newValue != oldValue && this.checkValidInputDate(newValue)) {
        var date_split = newValue.split("/");
        // dd/MM/yyyy => yyyy-MM-dd
        this.pick_date =
          date_split[2] + "-" + date_split[1] + "-" + date_split[0];
      }
    },
  },
  computed: {
    input_date: {
      get: function() {
        if (this.value == null || this.value == "Invalid Date") return "";
        if (!this.value.includes("/") && this.value.length > 10) {
          return this.$convert_date_string(this.value);
        }
        return this.value;
      },
      set: function(modifiedValue) {
        this.$emit("input", modifiedValue);
      },
    },
  },
  methods: {
    checkValidPickDate(str) {
      var t = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (t === null) return false;
      var y = parseInt(t[1], 10),
        m = parseInt(t[2], 10),
        d = parseInt(t[3]);
      //below should be more acurate algorithm
      if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
        return true;
      }
      return false;
    },
    checkValidInputDate(str) {
      var t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (t === null) return false;
      var d = parseInt(t[1]),
        m = parseInt(t[2], 10),
        y = parseInt(t[3], 10);
      //below should be more acurate algorithm
      if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style>
#master_datepicker__value_ {
  font-size: 0px;
}

input#master_input {
  border-color: #dfe3e7;
  border-right-color: #fff;
}
input#master_input:focus,
:focus-visible {
  /* box-shadow: 0 4px 2px -2px rgb(52 58 64 / 25%); */
  box-shadow: none;
  border-bottom: 1px solid #363b3f;
  background-color: #ededed;
}
input#master_input:disabled {
  background-color: #fff;
}
#master_datepicker.btn-secondary {
  background-color: #fff;
  border-color: #ced4da;
  border-left: none;
}
#master_datepicker svg.bi-calendar.b-icon.bi {
  fill: #363b3f;
}
#master_datepicker.btn-secondary:hover svg.bi-calendar-fill.b-icon.bi {
  fill: #fff;
}
#master_datepicker svg.bi-calendar-fill.b-icon.bi {
  fill: #363b3f;
}
/* #master_datepicker svg.bi-calendar.b-icon.bi:hover {
  fill: #ffffff;
}
#master_datepicker svg.bi-calendar-fill.b-icon.bi:hover {
  fill: #ffffff;
} */
#master_datepicker.btn-secondary:hover {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
}
</style>
